import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';


const baseUrl = environment.baseUrl;

@Injectable({
    providedIn: 'root'
})
export class LocationService {

    constructor(
        private http: HttpClient
    ) { }

    getCountryList(search?, only_region:boolean = false): Observable<any> {
        let params = new HttpParams();
        if (search) params = params.append('search', search);
        params = params.append('only_region', only_region ? 'true' : 'false')
        params = params.append('limit', '1000')

        let header = new HttpHeaders();
        header = header.append('Accept-Language', 'en');
        return this.http.get<any>(`${baseUrl}/locations/country/`, { headers: header, params });
    }

    getStateList(country_id?, search?): Observable<any> {
        let params = new HttpParams();
        params = params.append('country_id', country_id);

        params = params.append('limit', '1000')

        if (search) params = params.append('search', search);
        let header = new HttpHeaders();
        header = header.append('Accept-Language', 'en');
        return this.http.get<any>(`${baseUrl}/locations/state/`, { headers: header, params });
    }

    getCityList(state_id?, search?): Observable<any> {
        let params = new HttpParams();
        params = params.append('state_id', state_id);

        if (search) params = params.append('search', search);
        params = params.append('limit', '1000')
        let header = new HttpHeaders();
        header = header.append('Accept-Language', 'en');
        return this.http.get<any>(`/assets/cities/${state_id}.json`, { headers: header, params });
    }

    getTimeZoneList(): Observable<any[]> {
        return this.http.get<any[]>(`${baseUrl}/customers/timezones/`);
    }
}
